import React, { useState, useEffect } from "react";
// import CryptoES from "crypto-es";
import { useLocation, useNavigate, } from "react-router-dom"; // Add this import

import Results from "./Subcomponents/ResultsContainer";
import StateResults from "./Subcomponents/StateResultsContainer";
import TownResults from "./Subcomponents/TownResultsContainer";
import RadioButton from "./MapOfRoles/Roles";
import RadioButton2 from "./MapOfAnswers/Answers";
import MapOfSchools from "./MapOfSchools/MapofSchools";




import { authe, firebase } from "../Firebase/config";
import {
  getAuth,
  onAuthStateChanged,
  createUserWithEmailAndPassword,
  sendEmailVerification,
  signOut,
  deleteUser,
  signInWithEmailAndPassword,
} from "@firebase/auth";
import {
  getDoc,
  updateDoc,
  collection,
  addDoc,
  query,
  where,
  getDocs,
  deleteDoc,
  doc,
  setDoc,
  getCountFromServer,
  arrayUnion,
  arrayRemove,
} from "@firebase/firestore";
import axios from "axios";
import "./signup2.css";

import NavBar from "./Navbar";

const Signup = (props) => {
  const { route } = props;

  // Make sure useNavigate is called at the top level of the component
  const navigate = useNavigate();

  const location = useLocation(); // Add this hook with other hooks
  const userData = location.state?.userData; // Extract userData from location state

  // The existing userData extraction from route.params
  // This provides fallback if userData wasn't passed through location state
  const userDataFromRoute = route?.params?.userData || userData;

  // Extract individual values from userData for backwards compatibility
  const school3 = userData?.school || route?.params?.userData?.school;
  const state3 = userData?.state || route?.params?.userData?.state;
  const town3 = userData?.town || route?.params?.userData?.town;
  const role3 = userData?.role || route?.params?.userData?.role;
  const localfirstname3 = userData?.localfirstname || route?.params?.userData?.localfirstname;
  const locallastname3 = userData?.locallastname || route?.params?.userData?.locallastname;
  const email3 = userData?.email || route?.params?.userData?.email;
  const id3 = userData?.id || route?.params?.userData?.id;
  const classid3 = userData?.currentclass || route?.params?.userData?.currentclass;

  const existingnumber = userData?.parentphonenumber;
  const existingemail = userData?.parentemail;
  const existingpassword = userData?.passwordactual;




  console.log(
    existingpassword,
    school3,
    state3,
    town3,
    role3,
    localfirstname3,
    locallastname3,
    email3,
    classid3,
    "Brought over from userData"
  );

  const sections = [
    { Name: "Active Passes", key: 1 },
    { Name: "Search By Name", key: 2 },
    { Name: "Search By Date", key: 3 },
  ];

  const [selectedclass, setSelectedclass] = useState();
  const [activename, setActivename] = useState("Active Passes");

  const [email, setEmail] = useState("");
  const [parentemail, setParentemail] = useState("");
  const [phonenumber, setPhonenumber] = useState("");
  const [parentphonenumber, setParentphonenumber] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [validationMessage, setValidationMessage] = useState("");
  const [school, setschool] = useState("");
  const [searching, setSearching] = useState(false);
  const [searchingstate, setSearchingstate] = useState(false);
  const [searchingtowns, setSearchingtowns] = useState(false);
  const [filtered, setFiltered] = useState([]);
  const [filteredstates, setFilteredstates] = useState([]);
  const [filteredtowns, setFilteredtowns] = useState([]);
  const [filteredposts, setfilteredposts] = useState([]);
  const [todos, setTodos] = useState([]);
  const [townarray, setTownarray] = useState([]);
  const [number, setNumber] = useState(0);
  const [admin, setAdmin] = useState(false);
  const [onlyadmin, setOnlyadmin] = useState([]);
  const [encrypt, setEncrypt] = useState("");
  const [state, setState] = useState("");
  const [town, setTown] = useState("");
  const [newstatearray, setNewstatearray] = useState([]);
  const [newtownarray, setNewtownarray] = useState([]);

  const [localfirstname, setLocalfirstname] = useState("");
  const [locallastname, setLocallastname] = useState("");
  const [currentclass, setCurrentclass] = useState("");
  const [currentlocation, setCurrrentlocation] = useState("");
  const [nameoflocation, setNameoflocation] = useState("");
  const [originalschools, setOriginalschools] = useState([]);
  const [tempschool, setTempschool] = useState("");
  const [penaaltyminutes, setPenaltyminutes] = useState();

  const [listofmadestudents, setListofmadestudents] = useState([]);

  const [domain, setDomain] = useState("");
  const [domainend, setDomainend] = useState("");
  const [domainfromschool, setDomainfromschool] = useState();
  const [role, setRole] = useState();
  const [first, setFirst] = useState("");
  const [language, setLanguage] = useState("");
  const [selection, setSelection] = useState();
  const [parentlanguage, setParentlanguage] = useState("");
  const [languagecode, setLanguagecode] = useState("");
  const [parentlanguagecode, setParentlanguagecode] = useState("");
  const [studentid, setStudentid] = useState("");

  const [idoftheschoool, setIdoftheschool] = useState();

  const [selectedschool, setSelectedschool] = useState("");
  const [idselected, setIdselected] = useState("");
  const [showspinner, setShowspinner] = useState(true);

  const [adjustments2, setAdjustments2] = useState();
  const [overunderlocal2, setOverunderlocal2] = useState();
  const [abc2, setAbc2] = useState();
  const [classid2, setClassid2] = useState();
  const [emailll, setEmailll] = useState();
  const [teacheriscalled, setTeacheriscalled] = useState();
  const [readynow, setReadynow] = useState();
  const [readynow2, setReadynow2] = useState();
  const [idsofpasses, setIdsofpasses] = useState();
  const [idsofconsequences, setIdsofconsequences] = useState();
  const [newid, setNewid] = useState();
  const [newid2, setNewid2] = useState();

  const [childid, setChildid] = useState();
  const [parentid, setParentid] = useState();

  const [teacherid, setTeacherid] = useState();

  const [adminteacherid, setAdminteacherid] = useState();
  const [isnurse, setIsnurse] = useState(0);
  const [schoolexists, setSchoolexists] = useState();

  const [schoolid, setSchoolid] = useState();

  const [reset, setReset] = useState();

  const [text0, setText0] = useState("");
  const [text1, setText1] = useState("");
  const [text2, setText2] = useState("");
  const [text3, setText3] = useState("");
  const [text4, setText4] = useState("");
  const [text5, setText5] = useState("");
  const [text6, setText6] = useState("");
  const [text7, setText7] = useState("");
  const [text8, setText8] = useState("");
  const [text9, setText9] = useState("");
  const [text10, setText10] = useState("");
  const [text11, setText11] = useState("");
  const [text12, setText12] = useState("");
  const [text13, setText13] = useState("");
  const [text14, setText14] = useState("");
  const [text15, setText15] = useState("");
  const [text16, setText16] = useState("");
  const [text17, setText17] = useState("");
  const [text18, setText18] = useState("");
  const [text19, setText19] = useState("");
  const [text20, setText20] = useState("");
  const [text21, setText21] = useState("");
  const [text22, setText22] = useState("");
  const [text23, setText23] = useState("");
  const [text24, setText24] = useState("");

  const [emailwithdomain, setEmailwithdomain] = useState();
  const [runonce, setRunonce] = useState();

  const [initialcode, setInitialcode] = useState();
  const [verificationId, setVerificationId] = useState();
  const [verificationCode, setVerificationCode] = useState("");
  const [readytocompare, setReadytocompare] = useState();

  const [interstitialLoaded, setInterstitialLoaded] = useState(false);

  const [yourotp, setYourotp] = useState();
  const [seq, setSeq] = useState("");
  // Add a new state variable to store the user ID at component level
  const [uid, setUid] = useState("");

  const [phonenumberbefore, setPhonenumberbefore] = useState("");
  const [phonenumberbefore2, setPhonenumberbefore2] = useState("");

  const [personaldata, setPersonaldata] = useState();

  const [donotshow, setDonotshow] = useState();

  const justPasted = React.useRef(false);

  useEffect(() => {
    if (typeof role3 != "undefined") {
      setRole(role3);
    }
  }, [role3]);

  useEffect(() => {
    if (typeof state3 != "undefined") {
      setState(state3);
    }
  }, [state3]);

  useEffect(() => {
    if (typeof userData != "undefined") {
      console.log(userData, "This is the user data received in Signup2");
    }
  }, [userData]);

  useEffect(() => {
    if (typeof town3 != "undefined") {
      setTown(town3);
    }
  }, [town3]);

  useEffect(() => {
    if (typeof school3 != "undefined") {
      setschool(school3);
      setFirst("No");
      setShowspinner(false);
    }
  }, [school3]);

  useEffect(() => {
    if (typeof localfirstname3 != "undefined") {
      setLocalfirstname(localfirstname3);
      console.log("localfirstname3", localfirstname3);
    }
  }, [localfirstname3]);

  useEffect(() => {
    if (typeof locallastname3 != "undefined") {
      setLocallastname(locallastname3);
    }
  }, [locallastname3]);

  useEffect(() => {
    if (typeof email3 != "undefined") {
      setEmail(email3);
    }
  }, [email3]);


   useEffect(() => {
    if (typeof existingpassword != "undefined" && existingpassword !== "'Sign Up' Needed") {
      setPassword(existingpassword);
    }
  }, [existingpassword]);

  useEffect(() => {
    if (
      typeof phonenumberbefore != "undefined" &&
      phonenumberbefore.length == 10
    ) {
      setPhonenumber(phonenumberbefore);
    } else if (
      typeof phonenumberbefore != "undefined" &&
      phonenumberbefore.length == 11
    ) {
      alert("Please enter a valid 10-digit phone number (Do not include a 1 to begin).");
    }
    // Remove the unused expression (null)
    // Nothing needs to happen in this case
  }, [phonenumberbefore]);

  const onChanged = (text) => {
    setPhonenumberbefore(text.replace(/[^0-9]/g, ""));
    if (text == 1) {
      setPhonenumberbefore("");
    }
  };

  const isFirestoreOnlyUser =
    userData &&
    userData.googleclassroomid == userData.id &&
    userData.role == "Student";



  useEffect(() => {
    if (
      typeof phonenumberbefore2 != "undefined" &&
      phonenumberbefore2.length == 10
    ) {
      setParentphonenumber(phonenumberbefore2);
    } else if (
      typeof phonenumberbefore2 != "undefined" &&
      phonenumberbefore2.length == 11
    ) {
      alert("Please enter a valid 10-digit phone number (Do not include a 1 to begin).");
    }
    // Remove the no-op expression
  }, [phonenumberbefore2]);

  const onChanged2 = (text) => {
    if (justPasted.current) {
      justPasted.current = false;
      return;
    }
    setPhonenumberbefore2(text.replace(/[^0-9]/g, ""));
  };

  // const loadInterstitial = () => {
  //   console.log("Wat this function run *******8888888 fromm the previous page");

  //   const unsubscribeLoaded = interstitial.addAdEventListener(
  //     AdEventType.LOADED,
  //     () => {
  //       setInterstitialLoaded(true);
  //     }
  //   );

  //   const unsubscribeClosed = interstitial.addAdEventListener(
  //     AdEventType.CLOSED,
  //     () => {
  //       setInterstitialLoaded(false);
  //       interstitial.load();
  //     }
  //   );

  //   interstitial.load();

  //   return () => {
  //     unsubscribeClosed();
  //     unsubscribeLoaded();
  //   };
  // };

  // useEffect(() => {
  //   const unsubscribeInterstitialEvents = loadInterstitial();
  //   return () => {
  //     unsubscribeInterstitialEvents();
  //   };
  // }, []);

  // useEffect(() => {
  //   loadInterstitial();
  // }, []);

  const constructemail = (value, domainfromschool) => {
    let prefix = value.split(domainfromschool).join("");

    setEmail(prefix);
  };

  useEffect(() => {
    // Remove spaces from email
    if (email.includes(" ")) {
      setEmail(email.replace(/\s/g, ""));
      return; // Wait for next render to update emailwithdomain
    }

    // Always combine email and domainfor emailwithdomain
    if (typeof email !== "undefined" && typeof domainfromschool !== "undefined") {
      setEmailwithdomain(email + domainfromschool);
    } else if (typeof email !== "undefined") {
      setEmailwithdomain(email);
    }
  }, [email, domainfromschool]);

  useEffect(() => {
    if (typeof emailwithdomain != "undefined") {
      console.log(emailwithdomain, "This is the email with domain");
    }
  }, [emailwithdomain]);

  useEffect(() => {
    if (
      languagecode != "" &&
      language != "English" &&
      language != "Spanish" &&
      language != "Portuguese" &&
      typeof language != "undefined"
    ) {
      getnewlanguaage0();
      getnewlanguaage1();
      getnewlanguaage2();
      getnewlanguaage3();
      getnewlanguaage4();
      getnewlanguaage5();
      getnewlanguaage6();
      getnewlanguaage7();
      getnewlanguaage8();
      getnewlanguaage9();
      getnewlanguaage10();
      getnewlanguaage11();
      getnewlanguaage12();
      getnewlanguaage13();
      getnewlanguaage14();
      getnewlanguaage15();
      getnewlanguaage16();
      getnewlanguaage17();
      getnewlanguaage18();
      getnewlanguaage19();
      getnewlanguaage20();
      getnewlanguaage21();
      getnewlanguaage22();
      getnewlanguaage23();
      getnewlanguaage24();

      // if (interstitialLoaded == true) {

      //   interstitial.show();
      // }
    }
  }, [languagecode]);

  const getnewlanguaage0 = async () => {
    console.log(languagecode, "2 the languge code");

    if (
      language != "English" &&
      language != "Spanish" &&
      language != "Portuguese" &&
      languagecode != ""
    ) {
      setShowspinner(true);

      try {
        const response = await axios.post(
          "https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY",
          {
            source: "en",
            format: "text",
            q: "Passwords do not match.",
            target: languagecode,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        setText0(response.data.data.translations[0].translatedText);
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  const getnewlanguaage1 = async () => {
    console.log(languagecode, "2 the languge code");

    if (
      language != "English" &&
      language != "Spanish" &&
      language != "Portuguese" &&
      languagecode != ""
    ) {
      try {
        const response = await axios.post(
          "https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY",
          {
            source: "en",
            format: "text",
            q: "All fields must be filled out.",
            target: languagecode,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        setText1(response.data.data.translations[0].translatedText);
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  const getnewlanguaage2 = async () => {
    console.log(languagecode, "2 the languge code");

    if (
      language != "English" &&
      language != "Spanish" &&
      language != "Portuguese" &&
      languagecode != ""
    ) {
      try {
        const response = await axios.post(
          "https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY",
          {
            source: "en",
            format: "text",
            q: "All 'Student User' data will be deleted in July.",
            target: languagecode,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        setText2(response.data.data.translations[0].translatedText);
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  const getnewlanguaage3 = async () => {
    console.log(languagecode, "2 the languge code");

    if (
      language != "English" &&
      language != "Spanish" &&
      language != "Portuguese" &&
      languagecode != ""
    ) {
      try {
        const response = await axios.post(
          "https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY",
          {
            source: "en",
            format: "text",
            q: "Language of Parent/Guardian",
            target: languagecode,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        setText3(response.data.data.translations[0].translatedText);
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  const getnewlanguaage4 = async () => {
    console.log(languagecode, "2 the languge code");

    if (
      language != "English" &&
      language != "Spanish" &&
      language != "Portuguese" &&
      languagecode != ""
    ) {
      try {
        const response = await axios.post(
          "https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY",
          {
            source: "en",
            format: "text",
            q: "Your Phone Number",
            target: languagecode,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        setText4(response.data.data.translations[0].translatedText);
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  const getnewlanguaage5 = async () => {
    console.log(languagecode, "2 the languge code");

    if (
      language != "English" &&
      language != "Spanish" &&
      language != "Portuguese" &&
      languagecode != ""
    ) {
      try {
        const response = await axios.post(
          "https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY",
          {
            source: "en",
            format: "text",
            q: "Parent's Phone Number",
            target: languagecode,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        setText5(response.data.data.translations[0].translatedText);
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  const getnewlanguaage6 = async () => {
    console.log(languagecode, "2 the languge code");

    if (
      language != "English" &&
      language != "Spanish" &&
      language != "Portuguese" &&
      languagecode != ""
    ) {
      try {
        const response = await axios.post(
          "https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY",
          {
            source: "en",
            format: "text",
            q: "Your Email",
            target: languagecode,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        setText6(response.data.data.translations[0].translatedText);
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  const getnewlanguaage7 = async () => {
    console.log(languagecode, "2 the languge code");

    if (
      language != "English" &&
      language != "Spanish" &&
      language != "Portuguese" &&
      languagecode != ""
    ) {
      try {
        const response = await axios.post(
          "https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY",
          {
            source: "en",
            format: "text",
            q: "Password",
            target: languagecode,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        setText7(response.data.data.translations[0].translatedText);
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  const getnewlanguaage8 = async () => {
    console.log(languagecode, "2 the languge code");

    if (
      language != "English" &&
      language != "Spanish" &&
      language != "Portuguese" &&
      languagecode != ""
    ) {
      try {
        const response = await axios.post(
          "https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY",
          {
            source: "en",
            format: "text",
            q: "Confirm Password",
            target: languagecode,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        setText8(response.data.data.translations[0].translatedText);
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  const getnewlanguaage9 = async () => {
    console.log(languagecode, "2 the languge code");

    if (
      language != "English" &&
      language != "Spanish" &&
      language != "Portuguese" &&
      languagecode != ""
    ) {
      try {
        const response = await axios.post(
          "https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY",
          {
            source: "en",
            format: "text",
            q: "First Name",
            target: languagecode,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        setText9(response.data.data.translations[0].translatedText);
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  const getnewlanguaage10 = async () => {
    console.log(languagecode, "2 the languge code");

    if (
      language != "English" &&
      language != "Spanish" &&
      language != "Portuguese" &&
      languagecode != ""
    ) {
      try {
        const response = await axios.post(
          "https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY",
          {
            source: "en",
            format: "text",
            q: "Last Name",
            target: languagecode,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        setText10(response.data.data.translations[0].translatedText);
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  const getnewlanguaage11 = async () => {
    console.log(languagecode, "2 the languge code");

    if (
      language != "English" &&
      language != "Spanish" &&
      language != "Portuguese" &&
      languagecode != ""
    ) {
      try {
        const response = await axios.post(
          "https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY",
          {
            source: "en",
            format: "text",
            q: "Student Sign-Up",
            target: languagecode,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        setText11(response.data.data.translations[0].translatedText);
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };
  const getnewlanguaage12 = async () => {
    console.log(languagecode, "2 the languge code");

    if (
      language != "English" &&
      language != "Spanish" &&
      language != "Portuguese" &&
      languagecode != ""
    ) {
      try {
        const response = await axios.post(
          "https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY",
          {
            source: "en",
            format: "text",
            q: "Reset",
            target: languagecode,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        setText12(response.data.data.translations[0].translatedText);
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };
  const getnewlanguaage13 = async () => {
    console.log(languagecode, "2 the languge code");

    if (
      language != "English" &&
      language != "Spanish" &&
      language != "Portuguese" &&
      languagecode != ""
    ) {
      try {
        const response = await axios.post(
          "https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY",
          {
            source: "en",
            format: "text",
            q: "Already have an account?",
            target: languagecode,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        setText13(response.data.data.translations[0].translatedText);
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };
  const getnewlanguaage14 = async () => {
    console.log(languagecode, "2 the languge code");

    if (
      language != "English" &&
      language != "Spanish" &&
      language != "Portuguese" &&
      languagecode != ""
    ) {
      try {
        const response = await axios.post(
          "https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY",
          {
            source: "en",
            format: "text",
            q: "Sign In",
            target: languagecode,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        setText14(response.data.data.translations[0].translatedText);
      } catch (error) {
        console.error("Error:", error);
      }
      setShowspinner(false);
    }
  };

  const getnewlanguaage15 = async () => {
    console.log(languagecode, "2 the languge code");

    if (
      language != "English" &&
      language != "Spanish" &&
      language != "Portuguese" &&
      languagecode != ""
    ) {
      try {
        const response = await axios.post(
          "https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY",
          {
            source: "en",
            format: "text",
            q: "When Were You Born?",
            target: languagecode,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        setText15(response.data.data.translations[0].translatedText);
      } catch (error) {
        console.error("Error:", error);
      }
      setShowspinner(false);
    }
  };

  const getnewlanguaage16 = async () => {
    console.log(languagecode, "2 the languge code");

    if (
      language != "English" &&
      language != "Spanish" &&
      language != "Portuguese" &&
      languagecode != ""
    ) {
      try {
        const response = await axios.post(
          "https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY",
          {
            source: "en",
            format: "text",
            q: "Enter Your Phone Number",
            target: languagecode,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        setText16(response.data.data.translations[0].translatedText);
      } catch (error) {
        console.error("Error:", error);
      }
      setShowspinner(false);
    }
  };

  const getnewlanguaage17 = async () => {
    console.log(languagecode, "2 the languge code");

    if (
      language != "English" &&
      language != "Spanish" &&
      language != "Portuguese" &&
      languagecode != ""
    ) {
      try {
        const response = await axios.post(
          "https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY",
          {
            source: "en",
            format: "text",
            q: "Enter 'Code' Texted To Me",
            target: languagecode,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        setText17(response.data.data.translations[0].translatedText);
      } catch (error) {
        console.error("Error:", error);
      }
      setShowspinner(false);
    }
  };

  const getnewlanguaage18 = async () => {
    console.log(languagecode, "2 the languge code");

    if (
      language != "English" &&
      language != "Spanish" &&
      language != "Portuguese" &&
      languagecode != ""
    ) {
      try {
        const response = await axios.post(
          "https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY",
          {
            source: "en",
            format: "text",
            q: "Include Country Code",
            target: languagecode,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        setText18(response.data.data.translations[0].translatedText);
      } catch (error) {
        console.error("Error:", error);
      }
      setShowspinner(false);
    }
  };

  const getnewlanguaage19 = async () => {
    console.log(languagecode, "2 the languge code");

    if (
      language != "English" &&
      language != "Spanish" &&
      language != "Portuguese" &&
      languagecode != ""
    ) {
      try {
        const response = await axios.post(
          "https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY",
          {
            source: "en",
            format: "text",
            q: "Text Me Verification Code",
            target: languagecode,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        setText19(response.data.data.translations[0].translatedText);
      } catch (error) {
        console.error("Error:", error);
      }
      setShowspinner(false);
    }
  };

  const getnewlanguaage20 = async () => {
    console.log(languagecode, "2 the languge code");

    if (
      language != "English" &&
      language != "Spanish" &&
      language != "Portuguese" &&
      languagecode != ""
    ) {
      try {
        const response = await axios.post(
          "https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY",
          {
            source: "en",
            format: "text",
            q: "Confirm Verification Code",
            target: languagecode,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        setText20(response.data.data.translations[0].translatedText);
      } catch (error) {
        console.error("Error:", error);
      }
      setShowspinner(false);
    }
  };

  const getnewlanguaage21 = async () => {
    console.log(languagecode, "2 the languge code");

    if (
      language != "English" &&
      language != "Spanish" &&
      language != "Portuguese" &&
      languagecode != ""
    ) {
      try {
        const response = await axios.post(
          "https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY",
          {
            source: "en",
            format: "text",
            q: "Your code is: ",
            target: languagecode,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        setText21(response.data.data.translations[0].translatedText);
      } catch (error) {
        console.error("Error:", error);
      }
      setShowspinner(false);
    }
  };

  const getnewlanguaage22 = async () => {
    console.log(languagecode, "2 the languge code");

    if (
      language != "English" &&
      language != "Spanish" &&
      language != "Portuguese" &&
      languagecode != ""
    ) {
      try {
        const response = await axios.post(
          "https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY",
          {
            source: "en",
            format: "text",
            q: "Your Phone Number",
            target: languagecode,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        setText22(response.data.data.translations[0].translatedText);
      } catch (error) {
        console.error("Error:", error);
      }
      setShowspinner(false);
    }
  };

  const getnewlanguaage23 = async () => {
    console.log(languagecode, "2 the languge code");

    if (
      language != "English" &&
      language != "Spanish" &&
      language != "Portuguese" &&
      languagecode != ""
    ) {
      try {
        const response = await axios.post(
          "https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY",
          {
            source: "en",
            format: "text",
            q: "Parent's Email",
            target: languagecode,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        setText23(response.data.data.translations[0].translatedText);
      } catch (error) {
        console.error("Error:", error);
      }
      setShowspinner(false);
    }
  };

  const getnewlanguaage24 = async () => {
    console.log(languagecode, "2 the languge code");

    if (
      language != "English" &&
      language != "Spanish" &&
      language != "Portuguese" &&
      languagecode != ""
    ) {
      try {
        const response = await axios.post(
          "https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY",
          {
            source: "en",
            format: "text",
            q: "Missing Email",
            target: languagecode,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        setText24(response.data.data.translations[0].translatedText);
      } catch (error) {
        console.error("Error:", error);
      }
      setShowspinner(false);
    }
  };

  useEffect(() => {
    console.log(selection, "Hola");
  }, [selection]);

  const resetform = () => {
    setFilteredtowns();
    setFilteredstates();
    setFiltered();
    setIdselected("");
    setRole("");
    setEmail("");
    setParentemail("");
    setPassword("");
    setConfirmPassword("");
    setLocalfirstname("");
    setLocallastname("");
    setschool("");
    setTown("");
    setState("");
    setFirst("");
    setLanguage("");
    setLanguagecode("");
    setParentlanguage("");
    setParentlanguagecode("");
    setSelectedschool("");
    setTeacheriscalled("");
    setNameoflocation("");
    setValidationMessage("");
    setSelection();
    setPhonenumber("");
    setVerificationCode("");
    setVerificationId(false);
    setReadytocompare(false);
  };


  const auth = getAuth();

  const gotosignin = () => {
    auth.signOut();
    navigate("/SignIn");
  };


  useEffect(() => {
    if (typeof teacherid != "undefined") {
      checkmakeschoolforteacher();
    }
  }, [teacherid]);

  useEffect(() => {
    console.log(
      language,
      "dis is the languaage",
      locallastname,
      "locallastname"
    );
  }, [language]);

  useEffect(() => {
    console.log("1", idsofconsequences);
    if (
      typeof idsofconsequences != "undefined" &&
      typeof newid != "undefined"
    ) {
      for (let s = 0; s < idsofconsequences.length; s++) {
        updateDoc(doc(firebase, "consequencephoneuse", idsofconsequences[s]), {
          studentid: newid,
        }).catch((error) => {
          console.log(error);
          alert(error);
        });
      }
    }
  }, [newid, idsofconsequences]);

  // useEffect(() => {
  //   if (typeof language == "undefined" || language == "") {
  //     navigation.setOptions({
  //       headerLeft: () => (
  //         <div onPress={() => gotosignin()}>
  //           <div accessibilityLabel="Guest" className="error">
  //             Sign In
  //           </div>
  //         </div>
  //       ),
  //       headerRight: () => (
  //         <div onPress={() => resetform()}>
  //           <div accessibilityLabel="Guest" className="error">
  //             Reset
  //           </div>
  //         </div>
  //       ),
  //     });
  //   } else if (
  //     language != "English" &&
  //     language != "Spanish" &&
  //     language != "Portuguese"
  //   ) {
  //     navigation.setOptions({
  //       headerLeft: () => (
  //         <div onPress={() => gotosignin()}>
  //           <div accessibilityLabel="Guest" className="error">
  //             {text14}
  //           </div>
  //         </div>
  //       ),
  //       headerRight: () => (
  //         <div onPress={() => resetform()}>
  //           <div accessibilityLabel="Guest" className="error">
  //             {text12}
  //           </div>
  //         </div>
  //       ),
  //     });
  //   } else if (language == "Spanish") {
  //     navigation.setOptions({
  //       headerLeft: () => (
  //         <div onPress={() => gotosignin()}>
  //           <div accessibilityLabel="Guest" className="error">
  //             Iniciar sesión
  //           </div>
  //         </div>
  //       ),
  //       headerRight: () => (
  //         <div onPress={() => resetform()}>
  //           <div accessibilityLabel="Guest" className="error">
  //             Reiniciar
  //           </div>
  //         </div>
  //       ),
  //     });
  //   } else if (language == "Portuguese") {
  //     navigation.setOptions({
  //       headerLeft: () => (
  //         <div onPress={() => gotosignin()}>
  //           <div accessibilityLabel="Guest" className="error">
  //             Iniciar sessão
  //           </div>
  //         </div>
  //       ),
  //       headerRight: () => (
  //         <div onPress={() => resetform()}>
  //           <div accessibilityLabel="Guest" className="error">
  //             Restabelecer
  //           </div>
  //         </div>
  //       ),
  //     });
  //   } else {
  //     navigation.setOptions({
  //       headerLeft: () => (
  //         <div onPress={() => gotosignin()}>
  //           <div accessibilityLabel="Guest" className="error">
  //             Sign In
  //           </div>
  //         </div>
  //       ),
  //       headerRight: () => (
  //         <div onPress={() => resetform()}>
  //           <div accessibilityLabel="Guest" className="error">
  //             Reset
  //           </div>
  //         </div>
  //       ),
  //     });
  //   }
  // }, [text14, text12, language]);

  // useEffect(() => {
  //   navigation.setOptions({
  //     headerLeft: () => (
  //       <div onPress={() => gotosignin()}>
  //         <div accessibilityLabel="Guest" className="error">
  //           Sign In
  //         </div>
  //       </div>
  //     ),
  //     headerRight: () => (
  //       <div onPress={() => resetform()}>
  //         <div accessibilityLabel="Guest" className="error">
  //           Reset
  //         </div>
  //       </div>
  //     ),
  //   });
  // }, []);

  const data = [{ value: "Student" }, { value: "Teacher" }];


  const answers = [
    {
      value: "English",
      code: "en",
    },
    {
      value: "Spanish",
      code: "es",
    },
    {
      value: "Portuguese",
      code: "pt",
    },

    {
      value: "Afrikaans",
      code: "af",
    },
    {
      value: "Albanian",
      code: "sq",
    },
    {
      value: "Amharic",
      code: "am",
    },
    {
      value: "Arabic",
      code: "ar",
    },
    {
      value: "Armenian",
      code: "hy",
    },
    {
      value: "Azerbaijani",
      code: "az",
    },
    {
      value: "Basque",
      code: "eu",
    },
    {
      value: "Belarusian",
      code: "be",
    },
    {
      value: "Bengali",
      code: "bn",
    },
    {
      value: "Bosnian",
      code: "bs",
    },
    {
      value: "Bulgarian",
      code: "bg",
    },
    {
      value: "Catalan",
      code: "ca",
    },
    {
      value: "Cebuano",
      code: "ceb",
    },
    {
      value: "Chinese (Simplified)",
      code: "zh-CN",
    },
    {
      value: "Chinese (Traditional)",
      code: "zh-TW",
    },
    {
      value: "Corsican",
      code: "co",
    },
    {
      value: "Croatian",
      code: "hr",
    },
    {
      value: "Czech",
      code: "cs",
    },
    {
      value: "Danish",
      code: "da",
    },
    {
      value: "Dutch",
      code: "nl",
    },
    {
      value: "English",
      code: "en",
    },
    {
      value: "Esperanto",
      code: "eo",
    },
    {
      value: "Estonian",
      code: "et",
    },
    {
      value: "Finnish",
      code: "fi",
    },
    {
      value: "French",
      code: "fr",
    },
    {
      value: "Frisian",
      code: "fy",
    },
    {
      value: "Galician",
      code: "gl",
    },
    {
      value: "Georgian",
      code: "ka",
    },
    {
      value: "German",
      code: "de",
    },
    {
      value: "Greek",
      code: "el",
    },
    {
      value: "Gujarati",
      code: "gu",
    },
    {
      value: "Haitian Creole",
      code: "ht",
    },
    {
      value: "Hausa",
      code: "ha",
    },
    {
      value: "Hawaiian",
      code: "haw",
    },
    {
      value: "Hebrew",
      code: "iw",
    },
    {
      value: "Hindi",
      code: "hi",
    },
    {
      value: "Hmong",
      code: "hmn",
    },
    {
      value: "Hungarian",
      code: "hu",
    },
    {
      value: "Icelandic",
      code: "is",
    },
    {
      value: "Igbo",
      code: "ig",
    },
    {
      value: "Indonesian",
      code: "id",
    },
    {
      value: "Irish",
      code: "ga",
    },
    {
      value: "Italian",
      code: "it",
    },
    {
      value: "Japanese",
      code: "ja",
    },
    {
      value: "Javanese",
      code: "jw",
    },
    {
      value: "Kannada",
      code: "kn",
    },
    {
      value: "Kazakh",
      code: "kk",
    },
    {
      value: "Khmer",
      code: "km",
    },
    {
      value: "Korean",
      code: "ko",
    },
    {
      value: "Kurdish",
      code: "ku",
    },
    {
      value: "Kyrgyz",
      code: "ky",
    },
    {
      value: "Lao",
      code: "lo",
    },
    {
      value: "Latin",
      code: "la",
    },
    {
      value: "Latvian",
      code: "lv",
    },
    {
      value: "Lithuanian",
      code: "lt",
    },
    {
      value: "Luxembourgish",
      code: "lb",
    },
    {
      value: "Macedonian",
      code: "mk",
    },
    {
      value: "Malagasy",
      code: "mg",
    },
    {
      value: "Malay",
      code: "ms",
    },
    {
      value: "Malayalam",
      code: "ml",
    },
    {
      value: "Maltese",
      code: "mt",
    },
    {
      value: "Maori",
      code: "mi",
    },
    {
      value: "Marathi",
      code: "mr",
    },
    {
      value: "Mongolian",
      code: "mn",
    },
    {
      value: "Myanmar (Burmese)",
      code: "my",
    },
    {
      value: "Nepali",
      code: "ne",
    },
    {
      value: "Norwegian",
      code: "no",
    },
    {
      value: "Nyanja (Chichewa)",
      code: "ny",
    },
    {
      value: "Pashto",
      code: "ps",
    },
    {
      value: "Persian",
      code: "fa",
    },
    {
      value: "Polish",
      code: "pl",
    },
    {
      value: "Portuguese",
      code: "pt",
    },
    {
      value: "Punjabi",
      code: "pa",
    },
    {
      value: "Romanian",
      code: "ro",
    },
    {
      value: "Russian",
      code: "ru",
    },
    {
      value: "Samoan",
      code: "sm",
    },
    {
      value: "Scots Gaelic",
      code: "gd",
    },
    {
      value: "Serbian",
      code: "sr",
    },
    {
      value: "Sesotho",
      code: "st",
    },
    {
      value: "Shona",
      code: "sn",
    },
    {
      value: "Sindhi",
      code: "sd",
    },
    {
      value: "Sinhala (Sinhalese)",
      code: "si",
    },
    {
      value: "Slovak",
      code: "sk",
    },
    {
      value: "Slovenian",
      code: "sl",
    },
    {
      value: "Somali",
      code: "so",
    },
    {
      value: "Spanish",
      code: "es",
    },
    {
      value: "Sundanese",
      code: "su",
    },
    {
      value: "Swahili",
      code: "sw",
    },
    {
      value: "Swedish",
      code: "sv",
    },
    {
      value: "Tagalog (Filipino)",
      code: "tl",
    },
    {
      value: "Tajik",
      code: "tg",
    },
    {
      value: "Tamil",
      code: "ta",
    },
    {
      value: "Telugu",
      code: "te",
    },
    {
      value: "Thai",
      code: "th",
    },
    {
      value: "Turkish",
      code: "tr",
    },
    {
      value: "Ukrainian",
      code: "uk",
    },
    {
      value: "Urdu",
      code: "ur",
    },
    {
      value: "Uzbek",
      code: "uz",
    },
    {
      value: "Vietnamese",
      code: "vi",
    },
    {
      value: "Welsh",
      code: "cy",
    },
    {
      value: "Xhosa",
      code: "xh",
    },
    {
      value: "Yiddish",
      code: "yi",
    },
    {
      value: "Yoruba",
      code: "yo",
    },
    {
      value: "Zulu",
      code: "zu",
    },
  ];

  const answers2 = [{ value: "Yes" }, { value: "No" }];

  useEffect(() => {
    if (typeof school3 == "undefined") {
      let idselect = selectedschool.id;
      let state = selectedschool.state;
      let school = selectedschool.school;
      let town = selectedschool.town;
      // let first = selectedschool.localfirstname;
      // let last = selectedschool.locallastname;
      let em = selectedschool.email;
      let dooo = selectedschool.domain;

      let classid = selectedschool.classidmadefrom;

      setDomainfromschool(dooo);
      setIdselected(idselect);
      setEmailll(em);
      setState(state);
      setschool(school);
      setTown(town);
      // setLocalfirstname(first);
      setStudentid(idselect);
      // setLocallastname(last);
      setClassid2(classid);
      setIdoftheschool(idselect);
    }
  }, [selectedschool]);

  useEffect(() => {
    if (
      typeof emailwithdomain != "undefined" &&
      typeof emailwithdomain != "undefined"
    ) {
      const getdomain = email.substring(email.lastIndexOf("@"));
      const ending = emailwithdomain.substring(emailwithdomain.indexOf("@"));
      setDomain(getdomain);
      setDomainend(ending);
      console.log(getdomain, "yo", domainend, "after");
    }
  }, [emailwithdomain]);

  useEffect(() => {
    if (typeof domainend != "undefined") {
      console.log("this is the domain end ", domainend);
    }
  }, [domainend]);

  useEffect(() => {
    if (typeof domain != "undefined") {
      console.log("THI S is thee domain", domain);
    }
  }, [domain]);

  const stateArray = [
    {
      name: "Alabama",
      abbreviation: "AL",
    },
    {
      name: "Alaska",
      abbreviation: "AK",
    },
    {
      name: "American Samoa",
      abbreviation: "AS",
    },
    {
      name: "Arizona",
      abbreviation: "AZ",
    },
    {
      name: "Arkansas",
      abbreviation: "AR",
    },
    {
      name: "California",
      abbreviation: "CA",
    },
    {
      name: "Colorado",
      abbreviation: "CO",
    },
    {
      name: "Connecticut",
      abbreviation: "CT",
    },
    {
      name: "Delaware",
      abbreviation: "DE",
    },
    {
      name: "District Of Columbia",
      abbreviation: "DC",
    },
    {
      name: "Federated States Of Micronesia",
      abbreviation: "FM",
    },
    {
      name: "Florida",
      abbreviation: "FL",
    },
    {
      name: "Georgia",
      abbreviation: "GA",
    },
    {
      name: "Guam",
      abbreviation: "GU",
    },
    {
      name: "Hawaii",
      abbreviation: "HI",
    },
    {
      name: "Idaho",
      abbreviation: "ID",
    },
    {
      name: "Illinois",
      abbreviation: "IL",
    },
    {
      name: "Indiana",
      abbreviation: "IN",
    },
    {
      name: "Iowa",
      abbreviation: "IA",
    },
    {
      name: "Kansas",
      abbreviation: "KS",
    },
    {
      name: "Kentucky",
      abbreviation: "KY",
    },
    {
      name: "Louisiana",
      abbreviation: "LA",
    },
    {
      name: "Maine",
      abbreviation: "ME",
    },
    {
      name: "Marshall Islands",
      abbreviation: "MH",
    },
    {
      name: "Maryland",
      abbreviation: "MD",
    },
    {
      name: "Massachusetts",
      abbreviation: "MA",
    },
    {
      name: "Michigan",
      abbreviation: "MI",
    },
    {
      name: "Minnesota",
      abbreviation: "MN",
    },
    {
      name: "Mississippi",
      abbreviation: "MS",
    },
    {
      name: "Missouri",
      abbreviation: "MO",
    },
    {
      name: "Montana",
      abbreviation: "MT",
    },
    {
      name: "Nebraska",
      abbreviation: "NE",
    },
    {
      name: "Nevada",
      abbreviation: "NV",
    },
    {
      name: "New Hampshire",
      abbreviation: "NH",
    },
    {
      name: "New Jersey",
      abbreviation: "NJ",
    },
    {
      name: "New Mexico",
      abbreviation: "NM",
    },
    {
      name: "New York",
      abbreviation: "NY",
    },
    {
      name: "North Carolina",
      abbreviation: "NC",
    },
    {
      name: "North Dakota",
      abbreviation: "ND",
    },
    {
      name: "Northern Mariana Islands",
      abbreviation: "MP",
    },
    {
      name: "Ohio",
      abbreviation: "OH",
    },
    {
      name: "Oklahoma",
      abbreviation: "OK",
    },
    {
      name: "Oregon",
      abbreviation: "OR",
    },
    {
      name: "Palau",
      abbreviation: "PW",
    },
    {
      name: "Pennsylvania",
      abbreviation: "PA",
    },

    {
      name: "Puerto Rico",
      abbreviation: "PR",
    },
    {
      name: "Rhode Island",
      abbreviation: "RI",
    },
    {
      name: "South Carolina",
      abbreviation: "SC",
    },
    {
      name: "South Dakota",
      abbreviation: "SD",
    },
    {
      name: "Tennessee",
      abbreviation: "TN",
    },
    {
      name: "Texas",
      abbreviation: "TX",
    },
    {
      name: "Utah",
      abbreviation: "UT",
    },
    {
      name: "Vermont",
      abbreviation: "VT",
    },
    {
      name: "Virgin Islands",
      abbreviation: "VI",
    },
    {
      name: "Virginia",
      abbreviation: "VA",
    },
    {
      name: "Washington",
      abbreviation: "WA",
    },
    {
      name: "West Virginia",
      abbreviation: "WV",
    },
    {
      name: "Wisconsin",
      abbreviation: "WI",
    },
    {
      name: "Wyoming",
      abbreviation: "WY",
    },
  ];

  // useEffect(() => {
  //   setEncrypt(CryptoES.AES.encrypt(password, "Your Password").toString());
  // }, [password]);

  const validateAndSet = (value, valueToCompare, setValue) => {
    // Apply the new value to state first
    setValue(value);

    // Determine current password and confirm values depending on which field was changed
    const currentPassword = setValue === setPassword ? value : password;
    const currentConfirm = setValue === setConfirmPassword ? value : confirmPassword;

    // Only show "Passwords do not match." when both fields are non-empty and different
    if (currentPassword.length > 0 && currentConfirm.length > 0) {

      if (role === "Student" && existingpassword == "'Sign Up' Needed" && currentPassword !== currentConfirm) {
        setValidationMessage("Passwords do not match.");
        return;
      }

      if (role != "Student" && currentPassword !== currentConfirm) {
        setValidationMessage("Passwords do not match.");
        return;
      }


      // If passwords match, ensure required fields are present for student sign-up
      if (
        typeof localfirstname3 === "undefined" &&
        (localfirstname === "" ||
          typeof localfirstname === "undefined" ||
          locallastname === "" ||
          typeof locallastname === "undefined" ||
          email === "")
      ) {
        setValidationMessage("All fields must be filled out.");
        return;
      }

      // Ready state when passwords match and fields are present (or not required)
      setValidationMessage("All 'Student User' data will be deleted in July.");
      return;
    }

    // If one or both password fields are empty, clear validation to avoid premature messages
    setValidationMessage("");
  };

  useEffect(() => {
    if (
      role == "Student" && ((password == confirmPassword) || existingpassword != "'Sign Up' Needed") &&
      state != "" &&
      town != "" &&
      school != "" &&
      ((localfirstname != "" &&
        typeof localfirstname != "undefined" &&
        locallastname != "" &&
        typeof locallastname != "undefined"))
    ) {
      setValidationMessage("All 'Student User' data will be deleted in July.");
    }
    if
      (role != "Student" && (password == confirmPassword) &&
      state != "" &&
      town != "" &&
      school != "" &&
      (typeof teacheriscalled != "undefined" && teacheriscalled != "")
    ) {
      setValidationMessage("All 'Student User' data will be deleted in July.");
    }
  }, [
    state,
    town,
    school,
    password,
    confirmPassword,
    localfirstname,
    locallastname,
    teacheriscalled
  ]);

  useEffect(() => {
    if (typeof classid2 != "undefined" && typeof idselected != "undefined") {
      getadjustment();
    }
  }, [classid2, idselected]);

  const getadjustment = () => {
    if (idselected && classid2) {
      const docRef = doc(firebase, "users", idselected);

      const docData = getDoc(docRef).then((docSnap) => {
        let idd = classid2;
        let object = docSnap.data();

        if (typeof object[idd] != "undefined") {
          const whatever = object[idd].adjustments;
          const penaltyminutes = object[idd].penaltyminutes;
          const ovunder = object[idd].overunder;
          const level = object[idd].level;
          setAdjustments2(whatever);
          setPenaltyminutes(penaltyminutes);
          setOverunderlocal2(ovunder);
          setAbc2(level);
        }
      });
    }
  };


  // useEffect(() => {
  //   console.log(abc2, "This is the trigger");
  //   if (typeof abc2 != "undefined" && typeof readynow != "undefined") {

  //     signInWithEmailAndPassword(auth, emailll, "password")

  //       .then((userCredential) => {
  //         const usera = auth.currentUser;

  //         if (role == "Student") {

  //           deleteUser(usera).then(() => {
  //             // User deleted.
  //           }).catch((error) => {
  //             console.log(error, usera.uid, "AN ERROR WAS MADE")
  //           });
  //         }
  //       })
  //       .catch((error) => {
  //         const errorCode = error.code;
  //         const errorMessage = error.message;
  //         console.log(errorMessage);
  //       })
  //       .then(() => {
  //         navigation.navigate("Mainmenustudent", { readynow: readynow });
  //       })
  //   }
  // }, [readynow]);

  // useEffect(() => {
  //   if (idselected && typeof readynow != "undefined" && role == "Student") {
  //     deleteDoc(doc(firebase, "users", idselected))
  //   }
  //   console.log("2The old user Document has just been erased!");

  // }, [readynow]);

  useEffect(() => {
    if (role == "Student") {
      setInitialcode(Math.floor(Math.random() * 10000) + 1000);
    }
  }, [role]);


  // ...existing code...
  const signUpStudent = async () => {
    console.log()
    try {
      console.log("Signup2: Received userData from navigation state:", userData);
      console.log("Signup2: isFirestoreOnlyUser:", isFirestoreOnlyUser);

      const toArray = (v) => (Array.isArray(v) ? v : v ? [v] : []);
      const mergeUnique = (...vals) =>
        Array.from(new Set(vals.flatMap((v) => toArray(v)).filter(Boolean)));

      const updateClassStudentEntry = async (
        classId,
        matchEmail,
        newUid,
        parentLangCode,
        studentLangCode,
        parentEmailInput,
        parentPhoneInput
      ) => {
        if (!classId || !matchEmail || !newUid) {
          console.warn("updateClassStudentEntry: Missing required parameters.", {
            classId,
            matchEmail,
            newUid,
          });
          return;
        }

        try {
          const classRef = doc(firebase, "classesbeingtaught", classId);
          const classSnap = await getDoc(classRef);
          if (!classSnap.exists()) {
            console.warn("updateClassStudentEntry: Class document does not exist.", classId);
            return;
          }

          const classData = classSnap.data();
          const arr = Array.isArray(classData.studentIds) ? classData.studentIds : [];
          let changed = false;
          const normalizedMatch = String(matchEmail || "").toLowerCase();

          const newArr = arr.map((item) => {
            if (!item) return item;
            const itemEmail = String(item.email || "").toLowerCase();

            if (itemEmail !== normalizedMatch) return item;
            changed = true;

            return {
              ...item,
              firebasestudentid: newUid,
              parentemail: mergeUnique(item.parentemail, parentEmailInput),
              parentphonenumber: mergeUnique(item.parentphonenumber, parentPhoneInput),
              parentlanguagecode: parentLangCode || item.parentlanguagecode || "en",
              languagecode: studentLangCode || item.languagecode || "en",
            };
          });

          const validatedStudentIds = newArr.map((student) =>
            Object.fromEntries(
              Object.entries(student || {}).map(([key, value]) => [key, value === undefined ? null : value])
            )
          );

          if (changed) {
            await updateDoc(classRef, { studentIds: validatedStudentIds });
            console.log("Updated studentIds entry in class:", classId, matchEmail, newUid);
          } else {
            console.log("No matching studentIds entry found for email:", matchEmail, "in class:", classId);
          }
        } catch (err) {
          console.error("Error updating class studentIds:", err);
        }
      };

      if (isFirestoreOnlyUser) {
        console.log(
          isFirestoreOnlyUser,
          userData.email,
          userData.passwordactual,
          userData.parentemail,
          userData.parentphonenumber,
          userData.classlist
        );

        setShowspinner(true);
        try {
          const passwordToUse =
            userData.passwordactual === "'Sign Up' Needed" ? password : userData.passwordactual;

          const userCredential = await createUserWithEmailAndPassword(
            auth,
            userData.email,
            passwordToUse
          );
          const newUid = userCredential.user.uid;

          const mergedParentEmails = mergeUnique(userData.parentemail, parentemail);
          const mergedParentNumbers = mergeUnique(userData.parentphonenumber, parentphonenumber);

          const newUserData = {
            ...userData,
            id: newUid,
            language: language,
            languagecode: languagecode,
            parentlanguage: parentlanguage || "English",
            parentlanguagecode: parentlanguagecode || "en",
            parentemail: mergedParentEmails,
            parentphonenumber: mergedParentNumbers,
            password: passwordToUse,
            passwordactual: passwordToUse,
            phonenumber: phonenumber != "" && phonenumber.length == 10 ? phonenumber : "",
          };

          await setDoc(doc(firebase, "users", newUid), newUserData);

          const classlist = Array.isArray(userData.classlist) ? userData.classlist : [];
          for (let i = 0; i < classlist.length; i++) {
            try {
              await updateDoc(doc(firebase, "classesbeingtaught", classlist[i]), {
                students: arrayRemove(userData.id),
              });
            } catch (error) {
              console.error("Error removing old student ID from class:", classlist[i], error);
              alert(error);
            }

            try {
              await updateDoc(doc(firebase, "classesbeingtaught", classlist[i]), {
                students: arrayUnion(newUid),
                languagesinthisclass: arrayUnion(languagecode),
                languagesinthisclassparents: arrayUnion(parentlanguagecode),
              });
            } catch (error) {
              console.error("Error adding new student ID to class:", classlist[i], error);
              alert(error);
            }

            await updateClassStudentEntry(
              classlist[i],
              userData.email || emailwithdomain || email,
              newUid,
              parentlanguagecode,
              languagecode,
              mergedParentEmails,
              mergedParentNumbers
            );
          }

          if (userData.id) {
            try {
              await deleteDoc(doc(firebase, "users", userData.id));
            } catch (error) {
              console.error("Error deleting old user document:", userData.id, error);
            }
          } else {
            try {
              const q = query(
                collection(firebase, "users"),
                where("email", "==", userData.email),
                where("passwordactual", "==", userData.passwordactual)
              );
              const querySnapshot = await getDocs(q);
              querySnapshot.forEach(async (docSnap) => {
                try {
                  await deleteDoc(doc(firebase, "users", docSnap.id));
                } catch (error) {
                  console.error("Error deleting user document from query:", docSnap.id, error);
                }
              });
            } catch (error) {
              console.error("Error querying and deleting old user documents:", error);
            }
          }

          alert("Account created and info transferred!");

          navigate(`/role/Student/Mainmenustudents/id/${newUid}`, {
            state: { personaldata: newUserData }
          });


        } catch (error) {
          setShowspinner(false);
          console.error("Error creating account:", error);
          alert(
            "Error creating account: " +
            error.message +
            "\nphonenumberbefore2: " +
            phonenumberbefore2 +
            "\nparentemail (input): " +
            parentemail +
            "\nemail: " +
            (userData?.email || email3 || emailwithdomain) +
            "\npassword: " +
            (userData?.password || password) +
            "\nparentemail: " +
            (userData?.parentemail || parentemail) +
            "\nparentphonenumber: " +
            (userData?.parentphonenumber || parentphonenumber) +
            "\nclasslist: " +
            JSON.stringify(userData?.classlist)
          );
        }
      } else {
        try {
          console.log("signUP got run", email3);

          if (typeof email3 == "undefined") {
            if (
              password == confirmPassword &&
              validationMessage == "All 'Student User' data will be deleted in July."
            ) {
              const generatedSeq = (Math.floor(Math.random() * 10000) + 10000)
                .toString()
                .substring(1);

              setYourotp(generatedSeq);
              setShowspinner(true);

              try {
                const userCredential = await createUserWithEmailAndPassword(auth, emailwithdomain, password);
                const generatedUid = userCredential.user.uid;
                setChildid(generatedUid);

                const mergedParentEmails = mergeUnique(existingemail, parentemail);
                const mergedParentNumbers = mergeUnique(existingnumber, parentphonenumber);

                const data2 = {
                  otp: generatedSeq,
                  parentlanguage: parentlanguage || "English",
                  language: language || "English",
                  languagecode: languagecode || "en",
                  parentlanguagecode: parentlanguagecode || "en",
                  id: generatedUid,
                  role: "Student",
                  localfirstname,
                  locallastname,
                  email: emailwithdomain,
                  parentemail: mergedParentEmails,
                  phonenumber: phonenumber != "" && phonenumber.length == 10 ? phonenumber : "",
                  parentphonenumber: mergedParentNumbers,
                  password: password,
                  passwordactual: password,
                  school,
                  state,
                  town,
                  outonbathroompass: false,
                  currentclass: "",
                  currentlocation: "",
                  changemade: false,
                  status: "",
                  lastmistake: "",
                  lastmistaketime: 0,
                  passesallowedinweekifonpenalty: 2,
                  totalpassesinlastsevendays: 0,
                  unreadnotifications: "not begun",
                  unreadcountnotificationsparent: "not begun",
                  isverified: true,
                  recordofnotifications: [],
                  loggedon: [0],
                  gender: "she",
                  classlist: [],
                  teacherlist: [],
                  classid3: classid3 || "",
                  firstname: localfirstname,
                  lastname: locallastname,
                  passid: "",
                };

                setPersonaldata(data2);
                await setDoc(doc(firebase, "users", generatedUid), data2);

                localStorage.setItem("id", generatedUid);
                localStorage.setItem("role", role);
                localStorage.setItem("firstname", localfirstname);
                localStorage.setItem("lastname", locallastname);
                localStorage.setItem("school", school);
                localStorage.setItem("town", town);
                localStorage.setItem("state", state);
                localStorage.setItem("email", emailwithdomain);
                localStorage.setItem("parentphonenumber", parentphonenumber);
                localStorage.setItem("phonenumber", phonenumber);

                alert("You've just joined the school: '" + school + "!!!");
                let route = "/role/Student/Mainmenustudents/id/" + generatedUid;

                // Make sure navigate is defined
                if (typeof navigate === 'function') {
                  navigate(route, {
                    state: { data2 }
                  });
                } else {
                  console.error("navigate function is not defined!", typeof navigate);
                  // Use window.location as a fallback

                }
              } catch (error) {
                setShowspinner(false);
                console.error("Error during user creation:", error);
                setValidationMessage(error.message);
                alert(error.message);
              }
            } else {
              console.log("Passwords do not match!1", password, confirmPassword);
            }
          } else {
            if (
              validationMessage == "All 'Student User' data will be deleted in July."
            ) {
              try {
                const generatedSeq = (Math.floor(Math.random() * 10000) + 10000)
                  .toString()
                  .substring(1);

                setYourotp(generatedSeq);
                setShowspinner(true);

                const mergedParentEmails = mergeUnique(existingemail, parentemail);
                const mergedParentNumbers = mergeUnique(existingnumber, parentphonenumber);

                const data2 = {
                  otp: generatedSeq,
                  parentlanguage: parentlanguage || "English",
                  parentlanguagecode: parentlanguagecode || "en",
                  outonbathroompass: false,
                  currentlocation: "",
                  changemade: false,
                  status: "",
                  lastmistake: "",
                  lastmistaketime: 0,
                  passesallowedinweekifonpenalty: 2,
                  totalpassesinlastsevendays: 0,
                  unreadnotifications: "not begun",
                  unreadcountnotificationsparent: "not begun",
                  isverified: true,
                  recordofnotifications: [],
                  loggedon: [0],
                  gender: "she",
                  password: password,
                  passwordactual: password,
                  parentemail: mergedParentEmails,
                  phonenumber: phonenumber != "" && phonenumber.length == 10 ? phonenumber : "",
                  parentphonenumber: mergedParentNumbers,
                  language: language,
                  languagecode: languagecode,
                  language2: language,
                  localfirstname: localfirstname3,
                  locallastname: locallastname3,
                  email: email3,
                  role: "Student",
                  languagecode2: languagecode,
                  firstname: localfirstname,
                  lastname: locallastname,
                  classid3: classid3,
                  passid: "",
                  email3: email3,
                  id3: id3,
                  school3: school3,
                };

                let userExists = false;
                try {



                  console.group("🔍 [Part 3 Check] Verifying if User Exists via Sign-In");
                  console.log("Checking Email (emailwithdomain):", emailwithdomain);
                  console.log("Checking Password Value:", `"${password}"`);
                  console.groupEnd();


                  await signInWithEmailAndPassword(auth, emailwithdomain, password);
                  userExists = true;
                } catch (err) {
                  console.log("ℹ️ Pre-check sign-in outcome code:", err.code);
                  if (err.code === "auth/user-not-found") userExists = false;
                  else if (err.code === "auth/wrong-password") userExists = true;
                  else userExists = false;
                }

                if (userExists) {
                  console.log("↩️ User exists. Redirecting to ifauthalreadyinuse workflow...");

                  await ifauthalreadyinuse(data2);
                  return;
                }

                try {

                  console.group("🚀 [Firebase Auth Call] Branch 3 User Creation");
                  console.log("Target Email (email3):", email3);
                  console.log("Target Password Value:", `"${password}"`);
                  console.log("Target Password Type:", typeof password);
                  console.groupEnd();

                  const userCredential = await createUserWithEmailAndPassword(auth, email3, password);
                  const generatedUid = userCredential.user.uid;
                  setChildid(generatedUid);

                  console.log("✅ User created successfully. UID:", generatedUid);


                  const data3 = {
                    ...data2,
                    id: generatedUid,
                  };

                  await setDoc(doc(firebase, "users", generatedUid), data3);

                  if (id3) {
                    await deleteDoc(doc(firebase, "users", id3));
                  }

                  localStorage.setItem("id", generatedUid);
                  localStorage.setItem("role", role);
                  localStorage.setItem("firstname", localfirstname);
                  localStorage.setItem("lastname", locallastname);
                  localStorage.setItem("school", school);
                  localStorage.setItem("town", town);
                  localStorage.setItem("state", state);
                  localStorage.setItem("email", email3);
                  localStorage.setItem("parentphonenumber", parentphonenumber);
                  localStorage.setItem("phonenumber", phonenumber.toString());

                  setPersonaldata(data3);

                  try {
                    await updateDoc(doc(firebase, "classesbeingtaught", classid3), {
                      students: arrayRemove(id3),
                    });
                  } catch (error) {
                    console.error("Error removing old student ID from class:", classid3, error);
                    alert(error);
                  }

                  await updateClassStudentEntry(
                    classid3,
                    email3 || emailwithdomain || email,
                    generatedUid,
                    parentlanguagecode,
                    languagecode,
                    data3.parentemail,
                    data3.parentphonenumber
                  );

                  try {
                    await updateDoc(doc(firebase, "classesbeingtaught", classid3), {
                      students: arrayUnion(generatedUid),
                      languagesinthisclass: arrayUnion(languagecode),
                      languagesinthisclassparents: arrayUnion(parentlanguagecode),
                    });
                  } catch (error) {
                    console.error("Error adding new student ID to class:", classid3, error);
                    alert(error);
                  }

                  const matchEmail = email3 || emailwithdomain || email;
                  if (classid3) {
                    await updateClassStudentEntry(
                      classid3,
                      matchEmail,
                      generatedUid,
                      parentlanguagecode,
                      languagecode,
                      data3.parentemail,
                      data3.parentphonenumber
                    );
                  }

                  alert("You've just joined the school: '" + school + "!");

                  let route = "/role/Student/Mainmenustudents/id/" + generatedUid;

                  try {
                    navigate(route, {
                      state: { data3 }
                    });
                  } catch (navigationError) {
                    console.error("Direct navigation failed:", navigationError);
                    // Fallback to lastmove function
                    lastmove();
                  }
                } catch (error) {
                  setShowspinner(false);
                  console.error("Error during user creation:", error);
                  setValidationMessage(error.message);
                  alert(error.message);
                }
              } catch (error) {
                setShowspinner(false);
                console.error("Error during user creation:", error);
                setValidationMessage(error.message);
                alert(error.message);
              }
            } else {
              console.log("Passwords do not match!2", password, confirmPassword);
            }
          }
        } catch (error) {
          console.error("Error in signUpStudent:", error);
        }
      }
    } catch (error) {
      console.error("Critical error in signUpStudent:", error);
    }
  };
  // ...existing code...
  const updateClassStudentEntry = async (classId, matchEmail, newUid, parentlanguagecode) => {
    if (!classId || !matchEmail || !newUid) return;
    try {
      const classRef = doc(firebase, "classesbeingtaught", classId);
      const classSnap = await getDoc(classRef);
      if (!classSnap.exists()) return;
      const classData = classSnap.data();
      const arr = classData.studentIds || [];
      let changed = false;
      const normalizedMatch = (matchEmail || "").toString().toLowerCase();

      const newArr = arr.map((item) => {
        if (!item) return item;
        const itemEmail = (item.email || "").toString().toLowerCase();
        if (itemEmail === normalizedMatch) {
          changed = true;
          return {
            ...item,
            firebasestudentid: newUid,
            parentlanguagecode: parentlanguagecode || item.parentlanguagecode || "en",
          };
        }
        return item;
      });

      if (changed) {
        await updateDoc(classRef, { studentIds: newArr });
        console.log("Updated studentIds entry in class:", classId, matchEmail, newUid);
      } else {
        console.log("No matching studentIds entry found for email:", matchEmail, "in class:", classId);
      }
    } catch (err) {
      console.error("Error updating class studentIds:", err);
    }
  };



  async function ifauthalreadyinuse(data) {
    try {
      // Try to sign in the user instead

      console.group("🚀 [Firebase Auth Call] ifauthalreadyinuse Re-auth Check");
      console.log("Target Email (data.email3):", data?.email3);
      console.log("Target Password Value:", `"${data?.password}"`);
      console.log("Target Password Type:", typeof data?.password);
      console.groupEnd();

      const userCredential = await signInWithEmailAndPassword(auth, data.email3, data.password);
      const generatedUid = userCredential.user.uid;
      setUid(generatedUid);
      setChildid(generatedUid);

      // Update data.id in case it's not set
      data.id = generatedUid;

      setPersonaldata(data);

      const usersRef = firebase;

      // Update the user document with the latest data
      await setDoc(doc(usersRef, "users", generatedUid), data, { merge: true });

      localStorage.setItem("id", generatedUid);
      localStorage.setItem("role", data.role);
      localStorage.setItem("firstname", data.localfirstname);
      localStorage.setItem("lastname", data.locallastname);
      localStorage.setItem("school", data.school3);
      localStorage.setItem("town", data.town);
      localStorage.setItem("state", data.state);
      localStorage.setItem("email", data.email);
      localStorage.setItem("parentphonenumber", data.parentphonenumber);
      localStorage.setItem("phonenumber", data.phonenumber);

      try {
        await updateDoc(doc(firebase, "users", generatedUid), {
          ...data
        });
      } catch (error) {
        console.log("1here is error", error);
        alert(error);
      }


      try {
        await updateDoc(doc(firebase, "classesbeingtaught", data.classid3), {
          students: arrayRemove(data.id3),
        });
      } catch (error) {
        console.log("2here is error", error);
        alert(error);
      }

      await updateClassStudentEntry(data.classid3, data.email3 || emailwithdomain || email, generatedUid, data.parentlanguagecode);


      try {
        await updateDoc(doc(firebase, "classesbeingtaught", data.classid3), {
          students: arrayUnion(generatedUid),
          languagesinthisclass: arrayUnion(data.languagecode),
          languagesinthisclassparents: arrayUnion(data.parentlanguagecode),
        });
      } catch (error) {
        console.log("3here is error", error);
        alert(error);
      }


      alert("You've just joined the school: '" + data.school3 + "!");

      try {
        let route = "/role/Student/Mainmenustudents/id/" + generatedUid;
        if (typeof navigate === 'function') {
          navigate(route, {
            state: { data }
          });
        } else {
          console.error("navigate function is not defined!", typeof navigate);
        }
      } catch (navigationError) {
        console.error("Direct navigation failed:", navigationError);
        lastmove();
      }
    } catch (error) {
      setValidationMessage(error.message);
      alert(error.message);
    }
  }


  async function lastmove() {
    setTimeout(() => {
      setReadynow2(true);
      setShowspinner(false);
      // localStorage.setItem('id', childid);
    }, 10);
  }

  useEffect(() => {
    if (readynow2 == true && typeof personaldata != "undefined") {
      alert("Was this run?");
      let route = "/role/Student/Mainmenustudents";
      try {
        navigate(route, {
          state: {
            personaldata
          }
        });
      } catch (navigationError) {
        console.error("Navigation error:", navigationError);
        alert("Navigation failed: " + navigationError.message);

        // Fallback - try alternative navigation
        try {
          navigate("/role/Student/Mainmenustudents", { state: { personaldata } });
        } catch (fallbackError) {
          console.error("Fallback navigation also failed:", fallbackError);
          alert("Critical navigation error. Please restart the app.");
        }
      }
    }
  }, [readynow2, seq, uid, personaldata]); // Add uid to the dependency array

  useEffect(() => {
    if (typeof newid != "undefined" && role == "Teacher") {
      // route with id + pass state for Teacher
      const route = `/role/Teacher/mainmenu/id/${newid}`;
      navigate(route, {
        state: {
          school2: school,
          id2: newid,
          town2: town,
          role2: role,
          email2: emailwithdomain,
          teacheriscalled2: teacheriscalled,
          state2: state,
          parentemail2: parentemail,
        },
      });
    }
  }, [newid]);

  useEffect(() => {
    if (typeof school3 == "undefined") {
      setschool("");
      setTown("");
      setState("");

      if (todos.length == 0) {
        setShowspinner(true);
        newfunctio();
      }
    }
  }, []);

  const newfunctio = async () => {
    console.log("run1");
    let temporaryarray = [];
    const usersRef = query(collection(firebase, "schools"));

    const querySnapshot = await getDocs(usersRef).then(function (snapshot) {
      let array = [{ id: 123, notlisted: "notlisted" }];

      snapshot.forEach((doc) => {
        array.push(doc.data());
      });

      setOriginalschools(array);
    });

    setShowspinner(false);
  };

  const twobuttonalertteacher = () => {
    // Replace Alert.alert with window.alert for web context
    window.alert(
      "Welcome to FastClassPass!\n\nPlease be aware - all Student data collected from this App will be erased in July.\n\nBefore you create a class, be sure to go to settings and make the necessary adjustments."
    );
  };

  const signUpTeacher = () => {
    console.log(emailwithdomain, password, confirmPassword, validationMessage, role, teacheriscalled, school, state, town, currentclass, currentlocation, "emailwithdomain, password, confirmPassword, validationMessage, role, teacheriscalled, school, state, town, currentclass, currentlocation");
    if (
      password == confirmPassword &&
      validationMessage == "All 'Student User' data will be deleted in July."
    ) {
      createUserWithEmailAndPassword(auth, emailwithdomain, password)
        .then((userCredential) => {
          const uid = userCredential.user.uid;

          const data1 = {
            id: uid,
            role,
            teacheriscalled,
            email: emailwithdomain,
            password: password,
            passwordactual: password,
            school,
            state,
            town,
            currentclass,
            currentlocation,
            bathroompass: 10,
            nonbathroompass: 10,
            drinkpass: 5,
            lateststudentnote: "",
            latestparentnote: "",
            idofstudentnote: "",
            idofparentnote: "",

            access_token: "",
            refresh_token: "",
            expiry_date: "",
            activeclassid: "",
            activeclassname: "",
            bulletinarray: [],
            minutespromptingemail: 100,
            whowillbeemailed: 0,
            studentpassmessage: "Hi {Student Name}, You were just on a hall pass for {Student Time} minutes. That is too long.",
            parentpassmessage: "",
            minutespromptingtext: 100,
            getbacktoclassmessage: "Hi {Student Name}. You now have exceeded the time-limit of this pass. If you are done with the purpose of your pass return to class.",
          };

          const usersRef = firebase;

          setDoc(doc(usersRef, "users", uid), data1)
            .then(() => {
              localStorage.setItem("role", role);
              localStorage.setItem("teacheriscalled", teacheriscalled);
              localStorage.setItem("id", uid);
              localStorage.setItem("school", school);
              localStorage.setItem("town", town);
              localStorage.setItem("state", state);
              localStorage.setItem("email", emailwithdomain);

              if (admin) {
                alert("You've just created a new school: '" + school);
              } else {
                twobuttonalertteacher();
              }
            })
            .then(() => {
              setNewid(uid);
              setTeacherid(uid);
            })
            .catch((error) => {
              alert(error);
            });
        })
        .catch((error) => {
          setValidationMessage(error.message);
        });
    } else {
      console.log("Passwords do not match!4");
    }
  };

  const signUpAdmin = () => {
    if (
      password == confirmPassword &&
      validationMessage == "All 'Student User' data will be deleted in July."
    ) {
      createUserWithEmailAndPassword(auth, emailwithdomain, password).then(
        (userCredential) => {
          const usersRef = firebase;

          const uid = userCredential.user.uid;

          const data5 = {
            id: uid,
            role,
            teacheriscalled,
            email: emailwithdomain,
            password: password,
            email: emailwithdomain,
            passwordactual: password,
            currentlocation: nameoflocation,
            school,
            state: state,
            town,
            isnurse: isnurse,
          };
          setDoc(doc(usersRef, "users", uid), data5)
            .then(() => {
              localStorage.setItem("role", role);
              localStorage.setItem("teacheriscalled", teacheriscalled);
              localStorage.setItem("id", uid);
              localStorage.setItem("school", school);
              localStorage.setItem("town", town);
              localStorage.setItem("state", state);
              localStorage.setItem("email", emailwithdomain);

              if (admin) {
                alert("You've just created a new school: '" + school);
              } else {
                twobuttonalertteacher();
              }
            })
            .then(() => {
              setNewid(uid);
              setAdminteacherid(uid);
            })
            .catch((error) => {
              alert(error);
            });
        }
      );
    } else {
      alert("Passwords do not match!3");
    }
  };

  async function checkmakeschoolforteacher() {
    if (first == "No") {
      setSchoolexists(true);

    } else {
      const f = query(
        collection(firebase, "schools"),
        where("school", "==", school),
        where("state", "==", state),
        where("town", "==", town),
        where("domain", "==", domainend)
      );

      const snapshot1 = await getCountFromServer(f);
      const totalCount = snapshot1.data().count;
      console.log("3", totalCount);

      if (totalCount < 1) {
        makeschoolforteacher();
      }
    }
  }

  async function makeschoolforteacher() {
    const docRef = await addDoc(collection(firebase, "schools"), {
      school: school ? school : "",
      state: state ? state : "",
      town: town ? town : "",
      domain: domainend ? domainend : "",
      update: 0,
    }).then(async (userRec) => {
      const user = userRec.id;
      setSchoolid(userRec.id);

      await updateDoc(doc(firebase, "schools", user), {
        id: user,
      }).catch((error) => {
        console.log(error);
        alert(error);
      });

      // Create a default Admin account for this new school
      try {
        const adminEmail = "admin" + domainend;
        const adminPassword = "password";

        const adminCredential = await createUserWithEmailAndPassword(
          auth,
          adminEmail,
          adminPassword
        );
        const adminUid = adminCredential.user.uid;

        const adminData = {
          id: adminUid,
          role: "Admin",
          teacheriscalled: "Admin",
          email: adminEmail,
          password: adminPassword,
          passwordactual: adminPassword,
          currentlocation: "",
          school: school ? school : "",
          state: state ? state : "",
          town: town ? town : "",
          isnurse: 0,
          schoolid: user,
        };

        await setDoc(doc(firebase, "users", adminUid), adminData);
        console.log("Default admin account created:", adminEmail);
      } catch (adminError) {
        console.warn("Could not create default admin account:", adminError.message);
        // Non-fatal — teacher signup still succeeds
      }
    });
  }

  async function comparecodes() {
    if (verificationCode == initialcode) {
      setVerificationId(true);

      // showadvertisement();
    } else {
      setVerificationId(false);
      alert(
        "The code you entered is not the same as the one that was texted to you."
      );
    }
  }

  // async function showadvertisement() {
  //   if (interstitialLoaded == true) {

  //     interstitial.show();

  //   } else {
  //     null
  //   }
  // }

  const textsearched = (text) => {
    setSearching(true);
    let postss = [];
    for (let i in todos) {
      let match = false;
      let postt = todos[i];
      for (let prop in postt) {
        let lower = JSON.stringify(postt[prop]).toLowerCase();

        if (
          typeof school.toString() != "undefined" &&
          lower.startsWith(school.toString().toLowerCase(), 1)
        ) {
          match = true;
        }
      }
      if (match == true) {
        if (!postss.includes(postt.id)) {
          postss.push(postt)
        }
      }
    }
    setFiltered(postss);
  };

  const textsearchedtowns = (text) => {
    setSearchingtowns(true);
    let postss = [];
    for (let i in townarray) {
      let match = false;
      let postt = townarray[i];
      for (let prop in postt) {
        let lower = JSON.stringify(postt[prop]).toLowerCase();
        if (lower.startsWith(town.toString().toLowerCase(), 1)) {
          match = true;
        }
      }
      if (match == true) {
        if (!postss.includes(postt.id)) {
          postss.push(postt)
        }
      }
    }
    setFilteredtowns(postss);
  };

  const textsearchedstates = () => {
    setSearchingstate(true);

    console.log("an array of states1");
    let postss = [];
    for (let i in stateArray) {
      let match = false;
      let postt = stateArray[i];

      for (let prop in postt) {
        let lower = JSON.stringify(postt[prop]).toLowerCase();
        if (lower.startsWith(state.toString().toLowerCase(), 1)) {
          match = true;
        }
      }
      if (match == true) {
        if (!postss.includes(postt.id)) {
          postss.push(postt)
        }
      }
    }
    setFilteredstates(postss);
  };

  useEffect(() => {
    if (school) {
      textsearched(school);
      console.log("this has been input", school);
    }
  }, [school]);

  useEffect(() => {
    if (state) {
      textsearchedstates(state);
      console.log("this stae has been input", state);
    }
  }, [state]);

  useEffect(() => {
    if (town) {
      textsearchedtowns(town);
      console.log("this stae has been input", town);
    }
  }, [town]);

  const handlePaste = (event) => {
    const clipboardData = event.clipboardData || window.Clipboard;
    const pastedText = clipboardData.getData("text");

    // Remove unwanted elements from the pasted text
    const cleanedText1 = pastedText.replace(/-/g, ""); // Example: remove <br> tags

    const cleanedText2 = cleanedText1.replace("(", "");

    const cleanedText3 = cleanedText2.replace(")", "");

    const cleanedText4 = cleanedText3.replace(" ", "");

    setPhonenumberbefore(cleanedText4);
  };

  const handlePaste2 = (event) => {
    event.preventDefault(); // Prevent default paste behavior
    const clipboardData = event.clipboardData || window.Clipboard;
    const pastedText = clipboardData.getData("text");

    // Remove unwanted elements from the pasted text
    const cleanedText1 = pastedText.replace(/-/g, "");
    const cleanedText2 = cleanedText1.replace(/\(/g, "");
    const cleanedText3 = cleanedText2.replace(/\)/g, "");
    const cleanedText4 = cleanedText3.replace(/\s/g, "");

    setPhonenumberbefore2(cleanedText4);
    event.target.value = cleanedText4; // Ensure input value is in sync with state
    justPasted.current = true;
  };

  // Render components that replace React Native components
  return (
    <div className="App22">
      <NavBar
        donotshow={donotshow}
        role={role}
        sections={sections}
        setSelectedclass={setSelectedclass}
        activename={activename}
      />
      <div className="container1233">
        {validationMessage === "Passwords do not match." && language === "Spanish" ? (
          <p className="errorred">Las contraseñas no coinciden</p>
        ) : validationMessage === "Passwords do not match." && language === "Portuguese" ? (
          <p className="errorred">As senhas não coincidem</p>
        ) : validationMessage === "Passwords do not match." && language !== "English" && languagecode !== "" ? (
          <p className="errorred">{text0}</p>
        ) : validationMessage === "Passwords do not match." ? (
          <p className="errorred">{validationMessage}</p>
        ) : validationMessage === "All fields must be filled out." && language === "Spanish" ? (
          <p className="errorred">Todos los campos<br />deben ser llenados.</p>
        ) : validationMessage === "All fields must be filled out." && language === "Portuguese" ? (
          <p className="errorred">Todos os campos<br />devem ser preenchidos.</p>
        ) : validationMessage === "All fields must be filled out." && language !== "English" && languagecode !== "" ? (
          <p className="errorred">{text1}</p>
        ) : validationMessage === "All fields must be filled out." ? (
          <p className="errorred">All fields<br />must be filled out.</p>
        ) : validationMessage === "All 'Student User' data will be deleted in July." && language === "Spanish" ? (
          <p className="error">Todos los datos de 'Usuario'<br />se eliminarán en julio.</p>
        ) : validationMessage === "All 'Student User' data will be deleted in July." && language === "Portuguese" ? (
          <p className="error">Todos os dados do 'Usuário'<br />serão excluídos em julho.</p>
        ) : validationMessage === "All 'Student User' data will be deleted in July." && language !== "English" && languagecode !== "" ? (
          <p className="error">{text2}</p>
        ) : validationMessage === "All 'Student User' data will be deleted in July." ? (
          <p className="error">All 'Student User' data<br />will be deleted in July.</p>
        ) : (
          <p className="error">All 'Student User' data<br />will be deleted in July. </p>
        )}
      </div>

      {showspinner === false ? (
        <div className="container2">
          {!role && !isFirestoreOnlyUser ? (
            <div className="container77">
              <div className="subsection1">
                <p className="paragraph7">Select Your Role </p>
              </div>

              <div className="subsection2">
                <RadioButton
                  role={role}
                  data={data}
                  onSelect={(value) => setRole(value)}
                  town={town}
                />
              </div>
            </div>
          ) : typeof school3 === "undefined" &&
            first === "" &&
            (state === "" || typeof state === "undefined") &&
            (town === "" || typeof town === "undefined") &&
            (school === "" || typeof school === "undefined") && !isFirestoreOnlyUser ? (
            <div className="container77">
              <div className="subsection37">
                <p className="paragraph8">Select Your School</p>
              </div>
              <div className="subsection47 scrollable">
                <MapOfSchools
                  originalschools={originalschools}
                  setSelectedschool={setSelectedschool}
                  idselected={idselected}
                  setFirst={setFirst}
                  role={role}
                />
                <br />
                <br />
                <br />
              </div>
            </div>
          ) : (state &&
            town &&
            school &&
            role === "Student" &&
            language === "" &&
            languagecode === "") || (isFirestoreOnlyUser &&
              language === "" &&
              languagecode === "") ? (
            <div className="container7">
              <div className="subsection1">
                <p className="paragraph7">Set the language for this App</p>
              </div>
              <div className="subsection46 scrollable" style={{ maxHeight: '500px', overflowY: 'scroll' }}>
                <div className="subsection4">
                  <RadioButton2
                    town={town}
                    role={role}
                    answers={answers}
                    setLanguage={setLanguage}
                    setLanguagecode={setLanguagecode}
                    onSelect={(value) => setSelection(value)}
                  />
                  <br />
                  <br />
                </div>
              </div>
            </div>
          ) : (state &&
            town &&
            school &&
            role === "Student" &&
            language === "English" &&
            parentlanguage === "") || (isFirestoreOnlyUser &&
              language === "English" &&
              parentlanguage === "") ? (
            <div className="container7">
              <div className="subsection1">
                <p className="paragraph7">Language of Parent/Guardian</p>
              </div>
              <div className="subsection46 scrollable" style={{ maxHeight: '500px', overflowY: 'scroll' }}>
                <div className="subsection4">
                  <RadioButton2
                    town={town}
                    state={state}
                    role={role}
                    answers2={answers}
                    setParentlanguage={setParentlanguage}
                    setParentlanguagecode={setParentlanguagecode}
                    onSelect={(value) => setSelection(value)}
                  />
                  <br />
                  <br />
                </div>
              </div>
            </div>
          ) : (state &&
            town &&
            school &&
            role === "Student" &&
            language === "Spanish" &&
            parentlanguage === "") || (isFirestoreOnlyUser &&
              language === "Spanish" &&
              parentlanguage === "") ? (
            <div className="container7">
              <div className="subsection1">
                <p className="paragraph7">Idioma del padre/tutor</p>
              </div>
              <div className="subsection46 scrollable" style={{ maxHeight: '1000px', overflowY: 'auto' }}>
                <div className="subsection4">
                  <RadioButton2
                    town={town}
                    state={state}
                    role={role}
                    answers2={answers}
                    setParentlanguage={setParentlanguage}
                    setParentlanguagecode={setParentlanguagecode}
                    onSelect={(value) => setSelection(value)}
                  />
                  <br />
                  <br />
                </div>
              </div>
            </div>
          ) : (state &&
            town &&
            school &&
            role === "Student" &&
            language === "Portuguese" &&
            parentlanguage === "") || (isFirestoreOnlyUser &&
              language === "Portuguese" &&
              parentlanguage === "") ? (
            <div className="container7">
              <div className="subsection1">
                <p className="paragraph7">Idioma do Pai/Responsável</p>
              </div>
              <div className="subsection46 scrollable" style={{ maxHeight: '1000px', overflowY: 'auto' }}>
                <div className="subsection4">
                  <RadioButton2
                    town={town}
                    state={state}
                    role={role}
                    answers2={answers}
                    setParentlanguage={setParentlanguage}
                    setParentlanguagecode={setParentlanguagecode}
                    onSelect={(value) => setSelection(value)}
                  />
                  <br />
                  <br />
                </div>
              </div>
            </div>
          ) : (state &&
            town &&
            school &&
            role === "Student" &&
            parentlanguage === "") || (isFirestoreOnlyUser &&
              parentlanguage === "") ? (
            <div className="container7">
              <div className="subsection1">
                <p className="paragraph7">{text3}</p>
              </div>
              <div className="subsection46 scrollable" style={{ maxHeight: '1000px', overflowY: 'auto' }}>
                <div className="subsection4">
                  <RadioButton2
                    town={town}
                    state={state}
                    role={role}
                    answers2={answers}
                    setParentlanguage={setParentlanguage}
                    setParentlanguagecode={setParentlanguagecode}
                    onSelect={(value) => setSelection(value)}
                  />
                  <br />
                  <br />
                </div>
              </div>
            </div>
          ) : state &&
            town &&
            school &&
            role === "Student" &&
            parentlanguage !== "" ? (
            <div className="container2222">
              <div className="container">
                <input
                  className="Newrow"
                  placeholder={language === "English" ? "Your Phone Number" :
                    language === "Spanish" ? "Tu número de teléfono" :
                      language === "Portuguese" ? "Seu número de telefone" : text4}
                  type="text"
                  value={phonenumberbefore}
                  onChange={(e) => onChanged(e.target.value)}
                  onPaste={handlePaste}
                />
                <input
                  className="Newrow"
                  placeholder={language === "English" ? "Parent's Phone Number" :
                    language === "Spanish" ? "Número de teléfono de los padres" :
                      language === "Portuguese" ? "Número de telefone dos pais" : text5}
                  type="text"
                  value={phonenumberbefore2}
                  onChange={(e) => onChanged2(e.target.value)}
                  onPaste={handlePaste2}
                />
                <input
                  className="Newrow"
                  placeholder={language === "English" ? "Parent's Email" :
                    language === "Spanish" ? "Correo electrónico de los padres" :
                      language === "Portuguese" ? "E-mail dos pais" : text23}
                  value={parentemail}
                  onChange={(e) => setParentemail(e.target.value)}
                />
                {typeof email3 === "undefined" ? (
                  <>
                    <input
                      className="Newrow"
                      placeholder={language === "English" ? "Your Email" :
                        language === "Spanish" ? "Tu correo electrónico" :
                          language === "Portuguese" ? "Seu email" : text6}
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                    <span>{emailwithdomain}</span>
                  </>
                ) : null}
                {existingpassword == "'Sign Up' Needed"
                  ? <>  <input
                    className="Newrow"
                    placeholder={language === "English" ? "Password" :
                      language === "Spanish" ? "Contraseña" :
                        language === "Portuguese" ? "Senha" : text7}
                    type="text"
                    value={password}
                    onChange={(e) => validateAndSet(e.target.value, confirmPassword, setPassword)}
                    autoCapitalize="off"
                    autoCorrect="off"
                    spellCheck={false}
                    autoComplete="new-password"
                  />
                    <input
                      className="Newrow"
                      placeholder={language === "English" ? "Confirm Password" :
                        language === "Spanish" ? "Confirmar Contraseña" :
                          language === "Portuguese" ? "Confirme sua senha" : text8}
                      type="text"
                      value={confirmPassword}
                      onChange={(e) => validateAndSet(e.target.value, password, setConfirmPassword)}
                      autoCapitalize="off"
                      autoCorrect="off"
                      spellCheck={false}
                      autoComplete="new-password"
                    /> </> : null}
                {typeof localfirstname3 === "undefined" ? (
                  <input
                    className="Newrow"
                    placeholder={language === "English" ? "First Name" :
                      language === "Spanish" ? "Nombre de pila" :
                        language === "Portuguese" ? "Primeiro nome" : text9}
                    value={localfirstname}
                    onChange={(e) => setLocalfirstname(e.target.value)}
                  />
                ) : null}
                {typeof locallastname3 === "undefined" ? (
                  <input
                    className="Newrow"
                    placeholder={language === "English" ? "Last Name" :
                      language === "Spanish" ? "Apellido" :
                        language === "Portuguese" ? "Sobrenome" : text10}
                    value={locallastname}
                    onChange={(e) => setLocallastname(e.target.value)}
                  />
                ) : null}
              </div>
              <div className="touchable">
                {(languagecode != "" && parentlanguagecode != "" && (existingpassword != "'Sign Up' Needed")) ? (
                  <div className="passstart222">
                    <div className="innertext33" onClick={signUpStudent}>
                      {language === "Spanish" ? "Registro de estudiante" :
                        language === "Portuguese" ? "Aluno Inscreva-se" :
                          language !== "English" && language !== "" ? text11 :
                            "Student Sign Upp"}
                    </div></div>
                ) : (isFirestoreOnlyUser && languagecode != "" && parentlanguagecode != "" && (existingpassword == "'Sign Up' Needed") && password == confirmPassword && password != "") ? (
                  <div className="passstart222">
                    <div className="innertext33" onClick={signUpStudent}>
                      {language === "Spanish" ? "Registro de estudiante" :
                        language === "Portuguese" ? "Aluno Inscreva-se" :
                          language !== "English" && language !== "" ? text11 :
                            "Student Sign Up"}
                    </div></div>
                ) : role === "Student" && email.length === 0 ? (
                  <button className="paragraph227">
                    {language === "Spanish" ? "Correo electrónico faltante" :
                      language === "Portuguese" ? "E-mail ausente" :
                        language !== "English" && language !== "" ? text24 :
                          "Missing Email"}
                  </button>
                ) : (
                  <button className="paragraph227"> </button>
                )}
              </div>
            </div>
          ) : role === "Teacher" && first === "Yes" ? (
            <div className="container2222">
              <div className="container">
                <input
                  className="Newrow"
                  placeholder="(School) Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <span>{emailwithdomain}</span>
                <input
                  className="Newrow"
                  placeholder="Password"
                  type="text"
                  value={password}
                  onChange={(e) => validateAndSet(e.target.value, confirmPassword, setPassword)}
                  autoCapitalize="off"
                  autoCorrect="off"
                  spellCheck={false}
                  autoComplete="new-password"
                />
                <input
                  className="Newrow"
                  placeholder="Confirm Password"
                  type="text"
                  value={confirmPassword}
                  onChange={(e) => validateAndSet(e.target.value, password, setConfirmPassword)}
                  autoCapitalize="off"
                  autoCorrect="off"
                  spellCheck={false}
                  autoComplete="new-password"
                />
                <input
                  className="Newrow"
                  placeholder="How students refer to you"
                  value={teacheriscalled}
                  onChange={(e) => setTeacheriscalled(e.target.value)}
                />
                <input
                  className="Newrow"
                  placeholder="School"
                  value={school}
                  onChange={(e) => setschool(e.target.value)}
                />

                <input
                  className="Newrow"
                  placeholder="Town"
                  value={town}
                  onChange={(e) => setTown(e.target.value)}
                />
                <input
                  className="Newrow"
                  placeholder="State"
                  value={state}
                  onChange={(e) => setState(e.target.value)}
                />
                <div className="scrollable" style={{ maxHeight: '200px', width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <StateResults
                    filteredstates={filteredstates}
                    state={state}
                    setState={setState}
                    textsearchedstates={(value) => textsearchedstates(value)}
                    setSearchingstate={setSearchingstate}
                    searchingstate={searchingstate}
                    newstatearray={newstatearray}
                    setNewstatearray={setNewstatearray}
                    stateArray={stateArray}
                  />
                </div>
              </div>
              <div className="touchable">
                {/* Button logic for teacher */}
                {role === "Teacher" && state && showspinner !== true ? (
                  <div className="passstart222">
                    <div className="innertext33" onClick={signUpTeacher}>Teacher Sign Up
                    </div>
                  </div>
                ) : (
                  <button className="paragraph227"> </button>
                )}
              </div>
            </div>
          ) : role === "Teacher" && state && town && school ? (
            <div className="container2222">
              <div className="container">
                <input
                  className="Newrow"
                  placeholder="(School) Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <span>{emailwithdomain}</span>
                <input
                  className="Newrow"
                  placeholder="Password"
                  type="text"
                  value={password}
                  onChange={(e) => validateAndSet(e.target.value, confirmPassword, setPassword)}
                  autoCapitalize="off"
                  autoCorrect="off"
                  spellCheck={false}
                  autoComplete="new-password"
                />
                <input
                  className="Newrow"
                  placeholder="Confirm Password"
                  type="text"
                  value={confirmPassword}
                  onChange={(e) => validateAndSet(e.target.value, password, setConfirmPassword)}
                  autoCapitalize="off"
                  autoCorrect="off"
                  spellCheck={false}
                  autoComplete="new-password"
                />
                <input
                  className="Newrow"
                  placeholder="How students refer to you"
                  value={teacheriscalled}
                  onChange={(e) => setTeacheriscalled(e.target.value)}
                />
              </div>
              <div className="touchable">
                {/* Button logic for teacher */}
                {role === "Teacher" && state && showspinner !== true ? (
                  <div className="passstart222">
                    <div className="innertext33" onClick={signUpTeacher}>Teacher Sign Up
                    </div>
                  </div>
                ) : (
                  <button className="paragraph227"> </button>
                )}
              </div>
            </div>
          ) : null}
        </div>
      ) : (
        <div className="loading-container">
          {/* Empty container shown when spinner is active */}
        </div>
      )}

      {/* Loading Spinner */}
      {showspinner && (
        <div className="spinner-overlay">
          <div className="spinner-container">
            <div className="spinner"></div>
          </div>
        </div>
      )}

      {/* Ad Banner Placeholder */}
      <div className="ad-banner">
        {/* Web ad implementation would go here */}
        {/* <p className="ad-text">Advertisement</p> */}
      </div>

      <div className="spacing-bottom">
        <br />
        <br />
        <br />
        <br />
        <br />
      </div>
    </div>
  );
}

export default Signup;